export default "__VITE_IMAGE_ASSET__192f9655__";